export const url =
  // process.env.NODE_ENV === "production" ? "" : "http://DESKTOP-B0KA72Q:8091";
  // process.env.NODE_ENV === "production" ? "" : "http://192.168.191.155:8091";
// process.env.NODE_ENV === "production" ? "" : "https://nitttrc.edu.in";
//process.env.NODE_ENV === "production" ? "" : "http://localhost:8092";
//process.env.NODE_ENV === "production" ? "" : "http://user-Standard-PC-i440FX-PIIX-1996:8092";
process.env.NODE_ENV === "production" ? "https://nitttrc.edu.in:8092" : "https://nitttrc.edu.in:8092";



// export const imagepath = process.env.NODE_ENV === "production" ? "" + "/images" : "https://nitttrc.edu.in/images";
export const imagepath = process.env.NODE_ENV === "production" ? "" + "/images" : "http://user-Standard-PC-i440FX-PIIX-1996:8092/images";
